import React from 'react';
import { useTranslation } from 'react-i18next';
import './ContactPage.css';
import { PhoneIcon, MailIcon } from '../components/Icons';
import heroImage from '../images/ChefferieBakong.jpg';

export default function ContactPage() {
  const { t } = useTranslation();

  return (
    <div className="contact-page">
      {/* Image héros avec le titre "Contact" */}
      <header
        className="contact-hero"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="contact-hero-overlay">
          <h1>Contact</h1>
        </div>
      </header>

      {/* Bande blanche : téléphone et courriel, centrés */}
      <section className="contact-info-band">
        <div className="contact-info-item">
          <div className="contact-icon-circle">
            <PhoneIcon />
          </div>
          <p className="contact-info-label">{t('menu.contactCallLabel')}</p>
          <p className="contact-info-value">+1 437-860-3973</p>
        </div>

        <div className="contact-info-item">
          <div className="contact-icon-circle">
            <MailIcon />
          </div>
          <p className="contact-info-label">{t('menu.email')}</p>
          <p className="contact-info-value">secretariatgeneral@diasporabakong.com</p>
        </div>
      </section>
    </div>
  );
}
